/**
 * Meeting layout init template data
 *
 * @authors Luo-jinghui (luojinghui424@gmail.com)
 * @date  2019-10-24 20:41:38
 */

import { toMultiPicContentHighPriority, toMultiPicActiveHighPriority } from './utils'
import { ITypeTemplate, ITemplate, ITemplateObj } from '../type';
import { TempValType } from '../type/enum.type';
// const temp = {
// 	id: 'local',
// 	stream: {},
// 	position: [ 0.75, 0.125, 0.25, 0.33 ],
// 	roster: {},
// 	status: '',
// 	seat: 0,
// 	display: true
// };

/**
 * 画廊模式：
 * 2 0.2812
 * 3-4 0.5625
 * 5-6 0.375
 * 7-8 0.5625
 *
 * 演讲者模式：
 * 2-4 0.4218
 * 5-8 0.5625
 */

// 9:16的比例
export const RATE = 0.5625;

export const hidePosition = [-30, -30, 1, 1];

export const SPEAKER_TEMPLATE: ITypeTemplate = {
  "1-1": [
    {
      position: [0, 0, 1, 1],
      resolution: 1,
      type: TempValType.LOCAL
    },
  ],
  "2-1": [
    {
      position: [0.75, 0, 0.25, 0.333],
      resolution: 1,
      type: TempValType.LOCAL
    },
    {
      position: [0, 0, 0.75, 1],
      resolution: 3,
      type: TempValType.P1
    },
  ],
  "3-1": [
    {
      position: [0.75, 0, 0.25, 0.333],
      resolution: 1,
      type: TempValType.LOCAL
    },
    {
      position: [0, 0, 0.75, 1],
      resolution: 3,
      type: TempValType.P1
    },
    {
      position: [0.75, 0.333, 0.25, 0.333],
      resolution: 1
    },
  ],
  "4-1": [
    {
      position: [0.75, 0, 0.25, 0.333],
      resolution: 1,
      type: TempValType.LOCAL
    },
    {
      position: [0, 0, 0.75, 1],
      resolution: 3,
      type: TempValType.P1
    },
    {
      position: [0.75, 0.333, 0.25, 0.333],
      resolution: 1
    },
    {
      position: [0.75, 0.666, 0.25, 0.333],
      resolution: 1
    },
  ],
  "5-1": [
    {
      position: [0, 0.75, 0.25, 0.25],
      resolution: 1,
      type: TempValType.LOCAL
    },
    {
      position: [0.125, 0, 0.75, 0.75],
      resolution: 3,
      type: TempValType.P1
    },
    {
      position: [0.25, 0.75, 0.25, 0.25],
      resolution: 1
    },
    {
      position: [0.5, 0.75, 0.25, 0.25],
      resolution: 1
    },
    {
      position: [0.75, 0.75, 0.25, 0.25],
      resolution: 1
    },
  ],
  "6-1": [
    {
      position: [0, 0.75, 0.25, 0.25],
      resolution: 1,
      type: TempValType.LOCAL
    },
    {
      position: [0, 0, 0.75, 0.75],
      resolution: 3,
      type: TempValType.P1
    },
    {
      position: [0.25, 0.75, 0.25, 0.25],
      resolution: 1
    },
    {
      position: [0.5, 0.75, 0.25, 0.25],
      resolution: 1
    },
    {
      position: [0.75, 0.75, 0.25, 0.25],
      resolution: 1
    },
    {
      position: [0.75, 0.5, 0.25, 0.25],
      resolution: 1
    },
  ],
  "7-1": [
    {
      position: [0, 0.75, 0.25, 0.25],
      resolution: 1,
      type: TempValType.LOCAL
    },
    {
      position: [0, 0, 0.75, 0.75],
      resolution: 3,
      type: TempValType.P1
    },
    {
      position: [0.25, 0.75, 0.25, 0.25],
      resolution: 1
    },
    {
      position: [0.5, 0.75, 0.25, 0.25],
      resolution: 1
    },
    {
      position: [0.75, 0.75, 0.25, 0.25],
      resolution: 1
    },
    {
      position: [0.75, 0.5, 0.25, 0.25],
      resolution: 1
    },
    {
      position: [0.75, 0.25, 0.25, 0.25],
      resolution: 1
    },
  ],
  "8-1": [
    {
      position: [0, 0.75, 0.25, 0.25],
      resolution: 1,
      type: TempValType.LOCAL
    },
    {
      position: [0, 0, 0.75, 0.75],
      resolution: 3,
      type: TempValType.P1
    },
    {
      position: [0.25, 0.75, 0.25, 0.25],
      resolution: 1
    },
    {
      position: [0.5, 0.75, 0.25, 0.25],
      resolution: 1
    },
    {
      position: [0.75, 0.75, 0.25, 0.25],
      resolution: 1
    },
    {
      position: [0.75, 0.5, 0.25, 0.25],
      resolution: 1
    },
    {
      position: [0.75, 0.25, 0.25, 0.25],
      resolution: 1
    },
    {
      position: [0.75, 0, 0.25, 0.25],
      resolution: 1
    },
  ],
};

export const GALLERY_TEMPLATE: ITypeTemplate = {
  "1-1": [
    {
      position: [0, 0, 1, 1],
      resolution: 1,
      type: TempValType.LOCAL
    },
  ],
  "2-2": [
    {
      position: [0, 0, 0.5, 1],
      resolution: 3,
      type: TempValType.LOCAL
    },
    {
      position: [0.5, 0, 0.5, 1],
      resolution: 3,
      type: TempValType.P1
    },
  ],
  "3-2": [
    {
      position: [0, 0.5, 0.5, 0.5],
      resolution: 2,
      type: TempValType.LOCAL
    },
    {
      position: [0.25, 0, 0.5, 0.5],
      resolution: 2,
      type: TempValType.P1
    },
    {
      position: [0.5, 0.5, 0.5, 0.5],
      resolution: 2
    },
  ],
  "4-2": [
    {
      position: [0, 0.5, 0.5, 0.5],
      resolution: 2,
      type: TempValType.LOCAL
    },
    {
      position: [0, 0, 0.5, 0.5],
      resolution: 2,
      type: TempValType.P1
    },
    {
      position: [0.5, 0, 0.5, 0.5],
      resolution: 2
    },
    {
      position: [0.5, 0.5, 0.5, 0.5],
      resolution: 2
    },
  ],
  "5-2": [
    {
      position: [0, 0.5, 0.333, 0.5],
      resolution: 1,
      type: TempValType.LOCAL
    },
    {
      position: [0, 0, 0.333, 0.5],
      resolution: 1,
      type: TempValType.P1
    },
    {
      position: [0.333, 0, 0.333, 0.5],
      resolution: 1
    },
    {
      position: [0.666, 0, 0.333, 0.5],
      resolution: 1
    },
    {
      position: [0.333, 0.5, 0.333, 0.5],
      resolution: 1
    },
  ],
  "6-2": [
    {
      position: [0, 0.5, 0.333, 0.5],
      resolution: 1,
      type: TempValType.LOCAL
    },
    {
      position: [0, 0, 0.333, 0.5],
      resolution: 1,
      type: TempValType.P1
    },
    {
      position: [0.333, 0, 0.333, 0.5],
      resolution: 1
    },
    {
      position: [0.666, 0, 0.333, 0.5],
      resolution: 1
    },
    {
      position: [0.333, 0.5, 0.333, 0.5],
      resolution: 1
    },
    {
      position: [0.666, 0.5, 0.333, 0.5],
      resolution: 1
    },
  ],
  "7-2": [
    {
      position: [0, 0.666, 0.333, 0.333],
      resolution: 1,
      type: TempValType.LOCAL
    },
    {
      position: [0, 0, 0.333, 0.333],
      resolution: 1,
      type: TempValType.P1
    },
     {
      position: [0.333, 0, 0.333, 0.333],
      resolution: 1
    },
    {
      position: [0.666, 0, 0.333, 0.333],
      resolution: 1
    },
    {
      position: [0, 0.333, 0.333, 0.333],
      resolution: 1
    },
    {
      position: [0.333, 0.333, 0.333, 0.333],
      resolution: 1
    },
    {
      position: [0.666, 0.333, 0.333, 0.333],
      resolution: 1
    },
  ],
  "8-2": [
    {
      position: [0, 0.666, 0.333, 0.333],
      resolution: 1,
      type: TempValType.LOCAL
    },
    {
      position: [0, 0, 0.333, 0.333],
      resolution: 1,
      type: TempValType.P1
    },
    {
      position: [0.333, 0, 0.333, 0.333],
      resolution: 1
    },
     {
      position: [0.666, 0, 0.333, 0.333],
      resolution: 1
    },
    {
      position: [0, 0.333, 0.333, 0.333],
      resolution: 1
    },
    {
      position: [0.333, 0.333, 0.333, 0.333],
      resolution: 1
    },
    {
      position: [0.666, 0.333, 0.333, 0.333],
      resolution: 1
    },
    {
      position: [0.333, 0.666, 0.333, 0.333],
      resolution: 1
    },
  ],
  "9-2": [
    {
      position: [0, 0.666, 0.333, 0.333],
      resolution: 1,
      type: TempValType.LOCAL
    },
    {
      position: [0, 0, 0.333, 0.333],
      resolution: 1,
      type: TempValType.P1
    },
    {
      position: [0.333, 0, 0.333, 0.333],
      resolution: 1
    },
    {
      position: [0.666, 0, 0.333, 0.333],
      resolution: 1
    },
     {
      position: [0, 0.333, 0.333, 0.333],
      resolution: 1
    },
    {
      position: [0.333, 0.333, 0.333, 0.333],
      resolution: 1
    },
    {
      position: [0.666, 0.333, 0.333, 0.333],
      resolution: 1
    },
    {
      position: [0.333, 0.666, 0.333, 0.333],
      resolution: 1
    },
    {
      position: [0.666, 0.666, 0.333, 0.333],
      resolution: 1
    },
  ],
};


// template模版数据包含自己，所以length为6是，代表有5个远端画面，一个本地画面
// 增加rate，方便计算容器的宽高
export const COMMON_TEMPLATE: Partial<ITemplate> = {
  SPEAKER: {
    length: 8,
    temp: {
      0: SPEAKER_TEMPLATE["1-1"],
      1: SPEAKER_TEMPLATE["1-1"],
      2: SPEAKER_TEMPLATE["2-1"],
      3: SPEAKER_TEMPLATE["3-1"],
      4: SPEAKER_TEMPLATE["4-1"],
      5: SPEAKER_TEMPLATE["5-1"],
      6: SPEAKER_TEMPLATE["6-1"],
      7: SPEAKER_TEMPLATE["7-1"],
      8: SPEAKER_TEMPLATE["8-1"],
    },
    rate: {
      0: 0.5625,
      1: 0.5625,
      2: 0.4218,
      3: 0.4218,
      4: 0.4218,
      5: 0.5625,
      6: 0.5625,
      7: 0.5625,
      8: 0.5625,
    },
  },
  GALLERY: {
    length: 9,
    temp: {
      0: GALLERY_TEMPLATE["1-1"],
      1: GALLERY_TEMPLATE["1-1"],
      2: GALLERY_TEMPLATE["2-2"],
      3: GALLERY_TEMPLATE["3-2"],
      4: GALLERY_TEMPLATE["4-2"],
      5: GALLERY_TEMPLATE["5-2"],
      6: GALLERY_TEMPLATE["6-2"],
      7: GALLERY_TEMPLATE["7-2"],
      8: GALLERY_TEMPLATE["8-2"],
      9: GALLERY_TEMPLATE["9-2"],
    },
    rate: {
      0: 0.5625,
      1: 0.5625,
      2: 0.2812,
      3: 0.5625,
      4: 0.5625,
      5: 0.375,
      6: 0.375,
      7: 0.5625,
      8: 0.5625,
      9: 0.5625,
    },
  },
};

// content缩略视图
export const MULTI_PIC_CONTENT_HIGH_PRIORITY: ITemplateObj = toMultiPicContentHighPriority(COMMON_TEMPLATE.SPEAKER);

// content缩略共享
export const MULTI_PIC_ACTIVE_HIGH_PRIORITY: ITemplateObj = toMultiPicActiveHighPriority(COMMON_TEMPLATE.SPEAKER);

// content共享
export const TWO_PIC_PIP_TEMPLATE: ITypeTemplate = {
  "1-2": [
    {
      position: [0, 0, 1, 1],
      resolution: 4,
      zIndex: 1,
      type: TempValType.CONTENT
    },
    {
      position: [0, 0.75, 0.25, 0.25],
      resolution: 3, // 主会场/p1/local
      zIndex: 2,
      type: TempValType.LOCAL
    },
  ],
};
// content共享全视图
export const CONTENT_ONLY_TEMPLATE: ITypeTemplate = {
  "1-1": [
    {
      position: [0, 0, 1, 1],
      resolution: 4,
      type: TempValType.CONTENT
    },
  ],
};

// content共享演讲者
export const TWO_PIC_SYMMETRIC_TEMPLATE: ITypeTemplate = {
  "1-2": [
    {
      position: [0, 0, 0.5, 1],
      resolution: 4,
      type: TempValType.CONTENT
    },
    {
      position: [0.5, 0, 0.5, 1],
      resolution: 3, // 主会场/p1/local
      type: TempValType.LOCAL
    },
  ],
};


export const CONTENT_TEMPLATE: Partial<ITemplate> = {
  MULTI_PIC_CONTENT_HIGH_PRIORITY,
  MULTI_PIC_ACTIVE_HIGH_PRIORITY,
  TWO_PIC_PIP: { // 共享视图
    length: 2,
    temp: {
      2: TWO_PIC_PIP_TEMPLATE["1-2"],
    },
    rate: {
      2: 0.5625,
    },
  },
  CONTENT_ONLY: { // 共享全视图
    length: 1,
    temp: {
      1: CONTENT_ONLY_TEMPLATE["1-1"],
    },
    rate: {
      1: 0.5625,
    },
  },
  TWO_PIC_SYMMETRIC: { // 共享+演讲
    length: 2,
    temp: {
      2: TWO_PIC_SYMMETRIC_TEMPLATE["1-2"],
    },
    rate: {
      2: 0.2812,
    },
  },
};


export const TEMPLATE: Partial<ITemplate> = {
  ...COMMON_TEMPLATE,
  ...CONTENT_TEMPLATE,
}
